import {
    OKTA_AUTHENTICATED,
    OKTA_FETCH_USER,
    OKTA_IS_FETCHING,
    OKTA_GROUPS
} from './actionTypes'

import { getOktaUserGroups } from '../helpers/api'

export const authenticate = (authenticated = false) => {
    return {
        type: OKTA_AUTHENTICATED,
        value: authenticated
    }
}



const setUserInfo = (user) => {
    return {
        type: OKTA_FETCH_USER,
        user
    }
}

const fetching = () => {
    return {
        type: OKTA_IS_FETCHING
    }
}


const setUserGroups = (groups) => {
    return {
        type: OKTA_GROUPS,
        groups
    }
}


const fetchUserGroups = (id = -1) => dispatch => {
    return getOktaUserGroups(id)
        .then(data => {
            //if token is expired
            if(data && data.isTokenExpired) {
                console.error("Token is expired")
                localStorage.clear()
                window.location.href = "/"
                return;
            }
            //if token is not expired
            if (data && (typeof data.isTokenExpired === 'undefined' || data.isTokenExpired === false)) {
                dispatch(setUserGroups(data.groups))
            }
        })
        .catch(err => console.error(err))
}

export const fetchUserInfo = (userData) => dispatch => {
    //console.warn("FETCHING USER INFO", userData)
    dispatch(fetching())
    dispatch(fetchUserGroups())
    dispatch(setUserInfo(userData))
}